import Icon from '@atoms/Icon/Icon';
import Image from '@atoms/Image/Image';
import Text from '@atoms/Text/Text';
import { IArticleCard } from '@models/IArticleCard';
import { IImage } from '@models/IImage';
import ArticleCard from '@molecules/ArticleCard/ArticleCard';

export interface INewsAndInsightsFeatured {
  featuredArticle: IArticleCard;
  list: {
    trumpetText?: string;
    title: string;
    image: IImage;
    url: string;
  }[];
}

const NewsAndInsightsFeatured = ({
  featuredArticle,
  list,
}: INewsAndInsightsFeatured) => (
  <section className="tw-container tw-flex tw-gap-10 max-lg:tw-flex-col lg:tw-gap-8">
    <div className="lg:tw-mb-auto lg:tw-basis-1/2">
      <ArticleCard
        {...featuredArticle}
        titleVariant="ds-headline-2"
        truncateTitle={false}
      />
    </div>
    <ul className="tw-flex tw-flex-col tw-border-t-1 tw-border-grey-30 lg:tw-basis-1/2">
      {list.map((item) => (
        <li key={item.title}>
          <a
            className="tw-group tw-flex tw-gap-8 tw-border-b-1 tw-border-grey-30 tw-py-6 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-white focus:tw-ring-offset-2 focus:tw-ring-offset-grey-100 md:tw-py-8"
            href={item.url}
          >
            <div className="tw-flex-shrink-0 tw-basis-[140px] max-xl:tw-hidden">
              <Image image={item.image} sizes="140px" />
            </div>
            <div className="tw-w-full">
              {item.trumpetText && (
                <Text
                  variant="body-small"
                  className="tw-mb-3 tw-uppercase tw-text-grey-60 md:tw-mb-2"
                >
                  {item.trumpetText}
                </Text>
              )}
              <div className="tw-flex tw-w-full">
                <Text
                  variant="ds-headline-3"
                  className="tw-pr-3 tw-font-light tw-text-black"
                >
                  {item.title}
                </Text>
                <Icon
                  name="arrow-right"
                  className="tw-mb-auto tw-ml-auto tw-mt-1 tw-max-w-4 tw-shrink-0 tw-text-grey-40 tw-transition-colors group-hover:tw-text-grey-100 group-focus:tw-text-grey-100 md:tw-max-w-5"
                  size={20}
                />
              </div>
            </div>
          </a>
        </li>
      ))}
    </ul>
  </section>
);

export default NewsAndInsightsFeatured;
